import { uuidv7 } from '@qsms/shared'
import { useRef, useState } from 'react'
import { banco } from '../dados/banco.js'
import { comprimirImagem } from '../dados/imagem.js'
import { useArquivo } from '../dados/useArquivo.js'

/// Imagem anexada a um campo do checklist (tipo IMAGEM). Uma por campo.
///
/// Para várias fotos soltas na inspeção, veja `GaleriaFotos`.

interface Props {
  inspecaoId: string
  arquivoId: string | null
  somenteLeitura?: boolean
  onMudar: (arquivoId: string | null) => void
}

export function ImagemDoCampo({ inspecaoId, arquivoId, somenteLeitura, onMudar }: Props) {
  const entrada = useRef<HTMLInputElement | null>(null)
  const [ocupado, setOcupado] = useState(false)
  const previa = useArquivo(arquivoId).url

  async function escolher(arquivo: File) {
    setOcupado(true)
    try {
      const blob = await comprimirImagem(arquivo)
      const novoId = uuidv7()
      await banco.fotos.add({
        arquivoId: novoId,
        inspecaoId,
        blob,
        mimeType: blob.type,
        criadoEm: new Date().toISOString(),
        enviado: false,
      })
      // O arquivo anterior não sai daqui: quem grava a resposta o descarta depois
      // de gravar a nova. Apagar antes deixava a resposta apontando para o nada se
      // o app fechasse nesse meio tempo.
      onMudar(novoId)
    } finally {
      setOcupado(false)
    }
  }

  if (somenteLeitura) {
    return previa ? (
      <img src={previa} alt="" className="w-full rounded-lg border border-slate-200 object-cover" />
    ) : (
      <p className="text-sm text-slate-400">Sem imagem.</p>
    )
  }

  return (
    <div>
      <input
        ref={entrada}
        type="file"
        accept="image/*"
        // `capture` abre a câmera direto: em campo, quase sempre é foto do momento.
        capture="environment"
        className="hidden"
        onChange={(e) => {
          const arquivo = e.target.files?.[0]
          if (arquivo) void escolher(arquivo)
          e.target.value = ''
        }}
      />
      {previa ? (
        <>
          <img src={previa} alt="" className="max-h-64 w-full rounded-lg border border-slate-200 object-cover" />
          <div className="mt-2 flex gap-2">
            <button type="button" onClick={() => entrada.current?.click()} className="botao-neutro flex-1" disabled={ocupado}>
              Trocar
            </button>
            <button
              type="button"
              onClick={() => onMudar(null)}
              className="botao-perigo flex-1"
            >
              Remover
            </button>
          </div>
        </>
      ) : (
        <button
          type="button"
          onClick={() => entrada.current?.click()}
          className="botao-neutro w-full"
          disabled={ocupado}
        >
          {ocupado ? 'Processando…' : 'Adicionar imagem'}
        </button>
      )}
    </div>
  )
}
